import { Price } from 'src/types';
import { FilterOffer, IFilter } from './types';

const filterOffer = (offer: FilterOffer, filter: IFilter): boolean => {
  // Keep offers with missing info if we have a function defined for it
  return filter.missingInfoFn
    ? filter.filterFn(offer, filter.selection) || filter.missingInfoFn(offer)
    : filter.filterFn(offer, filter.selection);
};

function updateMainOffer(offer: Price, filter: IFilter): Price {
  if (filter.filterFn(offer, filter.selection)) {
    // Main offer is valid
    return offer;
  }
  if (!offer?.alternativePrices?.length) {
    return offer;
  }

  // Swap in first valid alternative offer as new main offer
  let firstFilteredAlternativeOffer = offer.alternativePrices?.find(alt =>
    filter.filterFn(alt, filter.selection)
  );
  if (!firstFilteredAlternativeOffer) {
    firstFilteredAlternativeOffer = offer.alternativePrices[0];
  }
  const newAlternatives = offer.alternativePrices;
  const pos = newAlternatives.indexOf(firstFilteredAlternativeOffer);
  newAlternatives.splice(pos);
  newAlternatives.unshift(firstFilteredAlternativeOffer);
  return {
    ...firstFilteredAlternativeOffer,
    authorizedDealer: offer.authorizedDealer,
    history: offer.history,
    store: offer.store,
    alternativePrices: newAlternatives,
  } as Price;
}

export const filterOffersGeneric = (
  offers: Price[],
  filter: IFilter
): Price[] => {
  if (!offers.length || !filter.active) {
    return offers;
  }

  if (!filter.filterAlternativeOffers || !offers[0].alternativePrices) {
    return offers.filter(mainOffer => filterOffer(mainOffer, filter));
  }

  // Filtering alternative offers
  const filteredOffers: Price[] = [];
  offers.forEach(offer => {
    const filteredAlternatives = offer.alternativePrices?.filter(alt => {
      if (!alt) {
        return false;
      }
      const modified = { ...alt };
      if (!offer.store?.featured) {
        // Treat stock status as missing for unfeatured offers
        modified.stock = null;
      }
      return filterOffer(modified, filter);
    });
    if (!filteredAlternatives?.length) {
      return;
    }
    const offerWithFilteredAlternatives = {
      ...offer,
      alternativePrices: filteredAlternatives,
    };
    filteredOffers.push(updateMainOffer(offerWithFilteredAlternatives, filter));
  });
  return filteredOffers;
};
